<template>
  <div class="statistics-page">
    <el-card class="statistics-overview" shadow="never" :body-style="{ padding: '0' }">
      <div class="overview-copy">
        <span class="section-kicker">DATA OVERVIEW</span>
        <h1>数据统计</h1>
      </div>
      <div class="overview-metrics">
        <div><strong>{{ formatNumber(totalWorks) }}</strong><span>收录作品</span></div>
        <div><strong>{{ statistics.gameType.type.length }}</strong><span>游戏类型</span></div>
        <div><strong>{{ statistics.languages.length }}</strong><span>作品语言</span></div>
      </div>
    </el-card>

    <app-scrollbar class="statistics-scroll" :class="{ 'is-loading': loading }" v-loading="loading">
      <div class="statistics-grid">
        <el-card class="statistics-chart-card" shadow="never" :body-style="{ padding: '0', height: '100%' }">
          <div class="chart-heading"><span class="section-kicker">TYPE × LANGUAGE</span><h2>类型与语言</h2><small>作品数量</small></div>
          <div class="chart-plot"><statistics-extra-chart kind="typeLanguages" :data="statistics.typeLanguages"></statistics-extra-chart></div>
        </el-card>
        <el-card class="statistics-chart-card" shadow="never" :body-style="{ padding: '0', height: '100%' }">
          <div class="chart-heading"><span class="section-kicker">RATINGS</span><h2>评分分布</h2><small>作品评分区间</small></div>
          <div class="chart-plot"><score-charts :data="statistics.scores"></score-charts></div>
        </el-card>
        <el-card class="statistics-chart-card" shadow="never" :body-style="{ padding: '0', height: '100%' }">
          <div class="chart-heading"><span class="section-kicker">LANGUAGES</span><h2>语言分布</h2><small>按作品语言统计</small></div>
          <div class="chart-plot"><language-charts :data="statistics.languages"></language-charts></div>
        </el-card>
        <el-card class="statistics-chart-card" shadow="never" :body-style="{ padding: '0', height: '100%' }">
          <div class="chart-heading"><span class="section-kicker">TIMELINE</span><h2>每年游戏数量</h2><small>历年收录趋势</small></div>
          <div class="chart-plot"><year-count-charts :data="statistics.years"></year-count-charts></div>
        </el-card>
        <el-card class="statistics-chart-card" shadow="never" :body-style="{ padding: '0', height: '100%' }">
          <div class="chart-heading"><span class="section-kicker">RECENT RELEASES</span><h2>每月发售数量</h2><small>近 24 个月</small></div>
          <div class="chart-plot"><statistics-extra-chart kind="months" :data="statistics.months"></statistics-extra-chart></div>
        </el-card>
        <el-card class="statistics-chart-card" shadow="never" :body-style="{ padding: '0', height: '100%' }">
          <div class="chart-heading"><span class="section-kicker">TAGS</span><h2>热门标签</h2><small>一部作品可有多个标签</small></div>
          <div class="chart-plot"><statistics-extra-chart kind="tags" :data="statistics.tags"></statistics-extra-chart></div>
        </el-card>
        <el-card class="statistics-chart-card statistics-chart-card--wide" shadow="never" :body-style="{ padding: '0', height: '100%' }">
          <div class="chart-heading"><span class="section-kicker">PRICE</span><h2>价格分布</h2><small>按实际售价 · 拖动查看全部价格</small></div>
          <div class="chart-plot"><statistics-extra-chart kind="prices" :data="statistics.prices"></statistics-extra-chart></div>
        </el-card>
        <el-card class="statistics-chart-card statistics-chart-card--wide" shadow="never" :body-style="{ padding: '0', height: '100%' }">
          <div class="chart-heading"><span class="section-kicker">RATING × SALES</span><h2>评分与销量</h2><small>仅显示有效评分及销量 · 纵轴为对数刻度</small></div>
          <div class="chart-plot"><statistics-extra-chart kind="scoreSales" :data="statistics.scoreSales"></statistics-extra-chart></div>
        </el-card>
      </div>
    </app-scrollbar>
  </div>
</template>

<script>
import LanguageCharts from '@/components/charts/LanguageCharts.vue'
import ScoreCharts from '@/components/charts/ScoreCharts.vue'
import YearCountCharts from '@/components/charts/YearCountCharts.vue'
import AppScrollbar from '@/components/AppScrollbar.vue'
import StatisticsExtraChart from '@/components/charts/StatisticsExtraChart.vue'
import axios from 'axios'

export default {
  name: 'GameStatistics',
  components: { LanguageCharts, ScoreCharts, YearCountCharts, AppScrollbar, StatisticsExtraChart },
  data() {
    return {
      loading: false,
      statistics: {
        scores: [],
        gameType: { type: [], counts: [] },
        languages: [],
        years: [],
        months: [],
        prices: [],
        tags: [],
        typeLanguages: [],
        scoreSales: []
      }
    }
  },
  computed: {
    totalWorks() {
      return this.statistics.years.reduce((sum, year) => sum + Number(year.value || 0), 0)
    }
  },
  created() {
    this.loadStatistics()
  },
  methods: {
    formatNumber(value) { return Number(value || 0).toLocaleString() },
    async loadStatistics() {
      this.loading = true
      try {
        const response = await axios.get('/api/open/statistics')
        if (response.data.code !== 200 || !response.data.data) throw new Error('统计数据加载失败')
        this.statistics = {
          ...this.statistics,
          ...response.data.data
        }
      } catch (error) {
        this.$message.error('统计数据加载失败，请稍后重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.statistics-page { display: flex; flex-direction: column; gap: 10px; height: 100%; min-height: 0; color: #303133; text-align: left; }
.statistics-overview, .statistics-chart-card { border: 1px solid rgba(220, 223, 230, .8); border-radius: 17px; background: rgba(255, 255, 255, .58); box-shadow: 0 10px 30px rgba(0, 0, 0, .08); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); }
.statistics-overview { flex: none; }
.statistics-overview >>> .el-card__body { display: flex; align-items: center; justify-content: space-between; gap: 24px; padding: 16px 24px !important; }
.section-kicker { color: #409eff; font-size: 10px; font-weight: 800; letter-spacing: .17em; }
.overview-copy h1 { margin: 5px 0 0; font-size: 24px; line-height: 1.25; }
.overview-metrics { display: flex; gap: 0; }
.overview-metrics > div { display: flex; flex-direction: column; min-width: 110px; padding: 0 20px; border-left: 1px solid rgba(220, 223, 230, .8); }
.overview-metrics strong { color: #409eff; font-size: 22px; line-height: 1.2; font-variant-numeric: tabular-nums; }
.overview-metrics span { margin-top: 4px; color: #909399; font-size: 11px; }
.statistics-scroll { flex: 1; min-height: 0; }
.statistics-scroll.is-loading { overflow-y: hidden; }
.statistics-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; padding-bottom: 2px; }
.statistics-chart-card { min-width: 0; height: 395px; overflow: hidden; }
.statistics-chart-card--wide { grid-column: 1 / -1; }
.statistics-chart-card >>> .el-card__body { display: flex; flex-direction: column; min-height: 0; }
.chart-heading { display: flex; align-items: baseline; flex: none; gap: 9px; padding: 18px 20px 11px; border-bottom: 1px solid rgba(220, 223, 230, .65); }
.chart-heading h2 { margin: 0; font-size: 18px; line-height: 1.3; }
.chart-heading small { margin-left: auto; color: #909399; font-size: 11px; white-space: nowrap; }
.chart-plot { flex: 1; min-height: 0; padding: 8px 12px 14px; }
@media (max-width: 1099px) { .statistics-grid { grid-template-columns: 1fr; } }
@media (max-width: 767px) {
  .statistics-overview >>> .el-card__body { display: block; padding: 13px 14px !important; }
  .overview-copy h1 { font-size: 20px; }
  .overview-metrics { justify-content: space-between; margin-top: 14px; padding-top: 11px; border-top: 1px solid rgba(220, 223, 230, .7); }
  .overview-metrics > div { min-width: 0; padding: 0 10px; }
  .overview-metrics > div:first-child { padding-left: 0; border-left: 0; }
  .overview-metrics strong { font-size: 16px; }
  .overview-metrics span { font-size: 10px; }
  .statistics-chart-card { height: 340px; }
  .chart-heading { align-items: flex-start; flex-wrap: wrap; gap: 4px 8px; padding: 13px 12px 9px; }
  .chart-heading h2 { font-size: 16px; }
  .chart-heading small { font-size: 10px; }
  .chart-plot { padding: 4px 5px 10px; }
}
</style>
